import { handleActions } from "redux-actions";
import {
  getRangeOptions,
  getSelectedRangeOption,
  getDateRanges,
  getSelectedRangeOptionWithCustom,
  getRangeOptionsWithCustom
} from "../../../../../../utils/date-range-options";
import {
  SET_LOADING,
  TOGGLE_OFFERS,
  SET_DATES,
  UPDATE_DATES,
  SET_FILTERS_LOADING,
  FETCH_CURRENT_USER_SUCCESS,
  UPDATE_CUSTOM_RANGE,
  FETCH_CONVERSION_VALUES_SUCCESS
} from "../sagas/retention/retention";

export const initialState = {
  currentUser: {},
  filtersDirty: false,
  datesDirty: false,
  filtersLoading: true,
  selectedRequestDates: {},
  isLoading: true,
  error: false,
  errorText: "",
  conversionInfo: {},
  toggleIntros: false,
  excludeIntrosToggleDisabled: true,
  rangeOptions: [],
  selectedRangeOption: {}
};

export default handleActions(
  {
    [TOGGLE_OFFERS]: (state, action) => ({
      ...state,
      toggleIntros: action.payload
    }),
    [FETCH_CONVERSION_VALUES_SUCCESS]: (state, action) => ({
      ...state,
      conversionInfo: action.payload.conversionInfo,
      isLoading: false,
      filtersLoading: false,
      filtersDirty: false,
      datesDirty: false,
      error: false
    }),
    [UPDATE_CUSTOM_RANGE]: (state, action) => ({
      ...state,
      selectedRangeOption: action.payload,
      selectedRequestDates: getDateRanges(
        state.currentUser.calendarEndDate,
        action.payload,
        state.currentUser.calendarStartDate
      ),
      datesDirty: true
    }),
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload || state.isLoading
    }),
    [SET_FILTERS_LOADING]: (state, action) => ({
      ...state,
      filtersLoading: action.payload || state.filtersLoading
    }),
    [SET_DATES]: (state, action) => {
      return {
        ...state,
        selectedRequestDates: action.payload || state.selectedRequestDates,
        rangeOptions: getRangeOptions(action.payload.endDate, state.currentUser.calendarStartDate),
        selectedRangeOption: getSelectedRangeOption(state.currentUser.calendarEndDate)
      };
    },
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates,
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
      selectedRangeOption: getSelectedRangeOptionWithCustom(action),
      datesDirty: true
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => {
      const currentUser = action.payload.params || state.currentUser;

      return {
        ...state,
        currentUser,
        filtersDirty: false,
        datesDirty: false
      };
    }
  },
  initialState
);
